import React from 'react';

import WsIconProps from './IconProps';

const Education: React.FC<WsIconProps> = ({ color = '#A0A4C0', width = 21, height = 17 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.49 6.19008L19.49 5.64008L10.49 0.640078H10.38C10.3187 0.614157 10.2551 0.594068 10.19 0.580078H10H9.82C9.75168 0.594077 9.68474 0.614157 9.62 0.640078H9.51L0.51 5.64008C0.356102 5.7273 0.228094 5.85378 0.139034 6.00662C0.0499749 6.15946 0.00305176 6.33318 0.00305176 6.51008C0.00305176 6.68697 0.0499749 6.8607 0.139034 7.01354C0.228094 7.16638 0.356102 7.29286 0.51 7.38008L3 8.76008V13.5001C3 14.2957 3.31607 15.0588 3.87868 15.6214C4.44129 16.184 5.20435 16.5001 6 16.5001H14C14.7956 16.5001 15.5587 16.184 16.1213 15.6214C16.6839 15.0588 17 14.2957 17 13.5001V8.76008L19 7.64008V10.5001C19 10.7653 19.1054 11.0196 19.2929 11.2072C19.4804 11.3947 19.7348 11.5001 20 11.5001C20.2652 11.5001 20.5196 11.3947 20.7071 11.2072C20.8946 11.0196 21 10.7653 21 10.5001V7.06008C20.9997 6.88288 20.9523 6.70895 20.8627 6.55608C20.7731 6.40321 20.6445 6.2769 20.49 6.19008ZM15 13.5001C15 13.7653 14.8946 14.0196 14.7071 14.2072C14.5196 14.3947 14.2652 14.5001 14 14.5001H6C5.73478 14.5001 5.48043 14.3947 5.29289 14.2072C5.10536 14.0196 5 13.7653 5 13.5001V9.87008L9.51 12.3701L9.66 12.4301H9.75C9.833 12.4405 9.917 12.4405 10 12.4301C10.083 12.4405 10.167 12.4405 10.25 12.4301H10.34C10.3931 12.4189 10.4438 12.3986 10.49 12.3701L15 9.87008V13.5001ZM10 10.3601L3.06 6.50008L10 2.64008L16.94 6.50008L10 10.3601Z"
      fill={color}
      fillOpacity="0.5"
    />
  </svg>
);

export default Education;
